import { SpacerProps } from './Spacer.types';

export const getDirectionDefaults = (direction?: SpacerProps['direction']) => {
  switch (direction) {
    case 'vertical': {
      return { flexDirection: 'column' };
    }
    case 'horizontal':
    default: {
      return { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' };
    }
  }
};

export const getGap = (size?: SpacerProps['gap']) => {
  if (typeof size === 'number') {
    return `${size}px`;
  }

  switch (size) {
    case 'l':
      return '32px';
    case 'm':
      return '16px';
    case 's':
    default:
      return '8px';
  }
};
